// extracted by mini-css-extract-plugin
module.exports = {"default":"LineAnimatedButton_default__YtjlC","inverse":"LineAnimatedButton_inverse__G3stj"};